import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'

import {
    Card, CardContent, Typography, CardHeader, IconButton,
    Table, TableBody, TableCell, TableRow, Hidden, Button
} from '@material-ui/core';

import { NumberSpinner } from '../../../components/InputControls'
import { withRouter } from 'react-router'
import { useDispatch, useSelector } from 'react-redux';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import Moment from 'moment';
import { actionDeleteUniqueCoupon } from 'actions';
import { actionRemoveCoupon, actionShopCartResetError, actionCalendarNavReset } from 'actions';


const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px"
    }
}));

const BookingTypeCard = props => {

    const { className, products } = props;
    const dispatch = useDispatch();
    const displateState = useSelector(state => state.reducerDisplayAreas);
    const [errorMsg, seterrorMsg] = useState("");
    const classes = useStyles();

    const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
    const shopCartError = useSelector(state => state.reducerShopCart.error);


    const CalculateMaxTickets = (TourEventID, TourProductID) => {

        let event = products.find(event => event.TourEventID == TourEventID);

        let fproduct = event.TourProducts.filter(p => p.TourProductID != TourProductID && p.AffectsCapacity);
        let consumedQty = 0;
        if (fproduct && fproduct.length > 0) {
            consumedQty = fproduct.reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }
        return event.TourProducts[0].MaximumTickets - consumedQty;
    }

    useEffect(() => {
        if (shopCartError && shopCartError.length > 0) {
            seterrorMsg(shopCartError)
        }
    }, [shopCartError])

    const changeQuantityHandler = (reference, value) => {

        if (ValidateQuanity(reference.eventId, reference.tourProductID, value)) {
            props.changeQuantityHandler(reference, value)
        }
    }

    const DeleteCouponsHolds = (CouponID) => {

        let removeCoupon = false;

        props.products.map(prod => {

            if (prod.CouponItems.filter(x => x.CouponID == CouponID && x.isUniqueCoupon).length < 2) {
                removeCoupon = true;
            }

        });

        return removeCoupon;
    }

    const removeclickhandler = (TourEventId, TourProductID, couponItems) => {


        let coupItem = couponItems ? couponItems.find(x => x.TourProductID == TourProductID && x.isUniqueCoupon) : null;

        if (coupItem) {
            if (DeleteCouponsHolds(coupItem.TourCouponID)) {
                actionDeleteUniqueCoupon(dispatch, coupItem.CouponHoldRef);
            }
        }

        CheckBeforeRemove(TourEventId, TourProductID);

        actionRemoveCoupon(dispatch, TourEventId, TourProductID);

        props.removeclickhandler(TourEventId, TourProductID);
    }

    const editClickHandler = (product) => {

        actionCalendarNavReset(dispatch);
        let bookType = bookingTypes.filter(x => x.BookingTypeID === product.BookingTypeID)[0];

        props.history.push({

            pathname: bookType.hasOwnProperty("UniqueBookingTypeID") ? '/calendar/' + bookType.UniqueBookingTypeID : '/calendar/Area/' + bookType.DisplayArea,
            event: product
        })
    }

    const errorcancelhandle = () => {
        seterrorMsg("");
        actionShopCartResetError(dispatch);
    }

    const CheckBeforeRemove = (TourEventId, TourProductID) => {
        let event = products.find(event => event.TourEventID == TourEventId);
        let MinTicket = event.TourProducts[0].MinimumTickets;
        let MaxTicket = event.TourProducts[0].MaximumTickets;

        let fproduct = event.TourProducts.filter(p => p.TourProductID != TourProductID & p.AffectsCapacity);
        let consumedQty = 0;
        if (fproduct && fproduct.length > 0) {
            consumedQty = fproduct.reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }

        if (consumedQty < MinTicket) {
            seterrorMsg("Minimum tickets for this event is " + MinTicket + ", please add more tickets.")
            return false;
        }
    }

    const ValidateQuanity = (TourEventId, TourProductID, changedqty) => {

        let event = products.find(event => event.TourEventID == TourEventId);
        let MinTicket = event.TourProducts[0].MinimumTickets;
        let MaxTicket = event.TourProducts[0].MaximumTickets;
        let selectedTPQty;

        if (event.TourProducts.find(x => x.TourProductID == TourProductID && x.AffectsCapacity)) {
            selectedTPQty = event.TourProducts.find(x => x.TourProductID == TourProductID && x.AffectsCapacity).Quantity;
        }

        let fproduct = event.TourProducts.filter(p => p.AffectsCapacity);
        let consumedQty = 0;
        if (fproduct && fproduct.length > 0) {
            consumedQty = fproduct.reduce((a, b) => {
                let aqty = a.Quantity === undefined ? 0 : a.Quantity;
                let bqty = b.Quantity === undefined ? 0 : b.Quantity;
                let newobj = { Quantity: aqty + bqty }
                return newobj;
            }).Quantity;
        }

        let newQty = changedqty - selectedTPQty;
        consumedQty = consumedQty + newQty;

        if (event.SeatsAvailable == 0 || event.BookNowOption != "Book Now") {
            seterrorMsg("Tickets not longer available, please choose another time");
            return false;
        }
        else if (consumedQty > event.SeatsAvailable) {
            seterrorMsg("Maximum of " + event.SeatsAvailable + " tickets available");
            return false;
        }
        else if (consumedQty < MinTicket) {
            seterrorMsg("Minimum tickets per order is " + MinTicket)
            return false;
        }
        else if (consumedQty > MaxTicket) {
            seterrorMsg("Maximum of " + MaxTicket + " tickets allowed")
            return false;
        }
        else {
            return true;
        }

    }


    const VisibleStartAndEndTime = (bookingtypeID, starttime) => {

        let time = "";

        const bookType = bookingTypes.filter(x => x.BookingTypeID == bookingtypeID)[0];

        if (bookType) {
            if (bookType.ShowStartTime && bookType.ShowEndTime) {
                time += Moment(starttime.EventStartDateTime).format('hh:mm a') + ' - ' + Moment(starttime.EventEndDateTime).format('hh:mm a');
            }

            if (bookType.ShowStartTime && !bookType.ShowEndTime) {
                time += Moment(starttime.EventStartDateTime).format('hh:mm a');
            }

            if (!bookType.ShowStartTime && bookType.ShowEndTime) {
                time += Moment(starttime.EventEndDateTime).format('hh:mm a');
            }
        }

        return time;

    }

    const ShowWebDisplayName = (bookingtypeID, webName) => {

        const bookType = bookingTypes.filter(x => x.BookingTypeID == bookingtypeID)[0];
        return bookType ? webName : '';
    }
    return (
        products.map(product => (
            <Card
                key={product.TourEventID}
                className={classes.root + ' ' + classes.tourbox}
            >
                <CardHeader className={classes.tourheaderbox}
                    action={<Typography variant="h5" className={classes.tourheadertext} color="inherit" component="h5">{window.matchMedia("(max-width: 500px)").matches ? '' : genfunction.GetEventDate(product.EventStartDateTime)}</Typography>}
                    title={window.matchMedia("(max-width: 500px)").matches ? ShowWebDisplayName(product.BookingTypeID, product.EventName) + ' ' + VisibleStartAndEndTime(product.BookingTypeID, product) + '  ' + genfunction.GetEventDate(product.EventStartDateTime) : ShowWebDisplayName(product.BookingTypeID, product.EventName) + ' ' + VisibleStartAndEndTime(product.BookingTypeID, product)}
                    titleTypographyProps={{ color: "inherit" }}
                    style={window.matchMedia("(max-width: 500px)").matches ? { textAlign: 'center' } : { textAlign: 'left' }}
                />
                <CardContent>
                    <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                    <Table size="small" className={classes.table} aria-label="spanning table">
                        <TableBody>
                            {product.TourProducts.map(item => (
                                <TableRow key={item.TourProductID}>
                                    <TableCell className={classes.tablecell} align="left">
                                        {!genfunction.IsEditEvent(bookingTypes, product) ?

                                            <IconButton
                                                edge="end"
                                                size="small"
                                                onClick={() => removeclickhandler(product.TourEventID, item.TourProductID, product.CouponItems)}
                                            >
                                                <CancelIcon
                                                    color={"error"}
                                                />
                                            </IconButton>
                                            : null

                                        }
                                    </TableCell>
                                    <TableCell className={classes.tablecell}>{item.TourProductName}</TableCell>
                                    <TableCell className={classes.tablecell} align="right">

                                        {genfunction.IsEditEvent(bookingTypes, product) ?
                                            <NumberSpinner refrence={{ eventId: product.TourEventID, tourProductID: item.TourProductID, eventCoupons: product.CouponItems }}
                                                value={parseInt(item.Quantity)}
                                                disabled={true}
                                                minValue={parseInt(item.Quantity)}
                                                maxValue={parseInt(item.Quantity)}
                                                changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}
                                            ></NumberSpinner>

                                            :
                                            <NumberSpinner refrence={{ eventId: product.TourEventID, tourProductID: item.TourProductID, eventCoupons: product.CouponItems }}
                                                value={parseInt(item.Quantity)}
                                                disabled={genfunction.UniqueCouponApplied(product.CouponItems, item.TourProductID, product.TourEventID)}
                                                minValue={1} maxValue={item.AffectsCapacity ? CalculateMaxTickets(product.TourEventID, item.TourProductID) : 999} steps={1}
                                                changeHandler={(refrence, value) => { changeQuantityHandler(refrence, value) }}></NumberSpinner>

                                        }
                                    </TableCell>
                                    <Hidden smDown>
                                        <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(item.PriceMatrix[0].Price)}</TableCell>
                                        <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(genfunction.priceRow(item.Quantity, item.PriceMatrix ? item.PriceMatrix[0].Price : 0))}</TableCell>
                                    </Hidden>
                                    <Hidden smUp>
                                        <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(genfunction.priceRow(item.Quantity, item.PriceMatrix && item.PriceMatrix.length > 0 ? item.PriceMatrix[0].Price : 0))}</TableCell>
                                    </Hidden>
                                </TableRow>
                            ))}

                            <TableRow>
                                <TableCell className={classes.tablecell} colSpan={2} />
                                <TableCell className={classes.tablecell} colSpan={1}>Subtotal</TableCell>
                                <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(product.TicketAmount)}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell className={classes.tablecell} colSpan={2} />
                                <TableCell className={classes.tablecell} colSpan={1}>Tax</TableCell>
                                <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(product.TaxAmount)}</TableCell>
                            </TableRow>
                            <TableRow>

                                <TableCell className={classes.tablecell} colSpan={2}  >
                                    {genfunction.IsEditEvent(bookingTypes, product) ?
                                        <Button variant="contained" size="small" color="primary"
                                            style={{ marginLeft: "15px" }}
                                            onClick={() => editClickHandler(product)} >
                                            Edit
                                        </Button> : null}
                                </TableCell>

                                <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}>Total</TableCell>
                                <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(product.TotalAmount)}</TableCell>
                            </TableRow>

                        </TableBody>
                    </Table>
                </CardContent>
            </Card >

        ))
    );
};

BookingTypeCard.propTypes = {
    products: PropTypes.array.isRequired,
    removeclickhandler: PropTypes.func
};

export default withRouter(BookingTypeCard);
